var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10C12.75 9.30964 13.3096 8.75 14 8.75C14.6904 8.75 15.25 9.30964 15.25 10C15.25 10.6904 14.6904 11.25 14 11.25C13.3096 11.25 12.75 10.6904 12.75 10Z",
    fill: "#FD8A24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10571 5.10571C6.93419 3.27723 9.41414 2.25 12 2.25C14.5859 2.25 17.0658 3.27723 18.8943 5.10571C20.7228 6.93419 21.75 9.41414 21.75 12C21.75 13.2804 21.4978 14.5482 21.0078 15.7312C20.5178 16.9141 19.7997 17.9889 18.8943 18.8943C17.9889 19.7997 16.9141 20.5178 15.7312 21.0078C14.5482 21.4978 13.2804 21.75 12 21.75C10.7196 21.75 9.45176 21.4978 8.26884 21.0078C7.08591 20.5178 6.01108 19.7997 5.10571 18.8943C4.20034 17.9889 3.48216 16.9141 2.99217 15.7312C2.50219 14.5482 2.25 13.2804 2.25 12C2.25 9.41414 3.27723 6.93419 5.10571 5.10571ZM14 7.25C12.4812 7.25 11.25 8.48122 11.25 10C11.25 10.4869 11.3765 10.9442 11.5985 11.3409L7.96967 14.9697C7.67678 15.2626 7.67678 15.7374 7.96967 16.0303L9.46967 17.5303C9.76256 17.8232 10.2374 17.8232 10.5303 17.5303C10.8232 17.2374 10.8232 16.7626 10.5303 16.4697L9.56066 15.5L10.5 14.5607L11.4697 15.5303C11.7626 15.8232 12.2374 15.8232 12.5303 15.5303C12.8232 15.2374 12.8232 14.7626 12.5303 14.4697L11.5607 13.5L12.6591 12.4015C13.0558 12.6235 13.5131 12.75 14 12.75C15.5188 12.75 16.75 11.5188 16.75 10C16.75 8.48122 15.5188 7.25 14 7.25Z",
    fill: "#FD8A24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionActive);
export default __webpack_public_path__ + "static/media/permission-active.09d990d6156b1496a521a17e66aab1e8.svg";
export { ForwardRef as ReactComponent };